import { render, staticRenderFns } from "./KpiOffice.vue?vue&type=template&id=3761552f&scoped=true"
import script from "./KpiOffice.vue?vue&type=script&lang=js"
export * from "./KpiOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3761552f",
  null
  
)

export default component.exports